<template>
  <v-card>
    <div>
      <v-img
        :src="rede.capa || require('@/assets/posto-default.png')"
        aspect-ratio="2.75"
      >
        <v-layout pa-2 column fill-height class="lightbox white--text">
          <v-spacer></v-spacer>
          <v-flex shrink>
            <v-btn
              color="white"
              dark
              flat
              @click="qrcode = !qrcode"
            >
              {{qrcode ? 'ESCONDER' : 'VER'}} QR-CODE
            </v-btn>
          </v-flex>
        </v-layout>
      </v-img>
    </div>

    <v-card-text>
      <template v-if="qrcode">
        <v-container grid-list-md fluid v-if="rede && rede.matriz">
          <v-layout row wrap fill-height>
            <v-flex xs12 class="text-xs-center">
              <span class="headline secondary--text">QR Code {{rede.matriz.nome_fantasia}}</span>
              <div>
                <span class="headline secondary--text">CNPJ {{rede.matriz.cnpj}}</span>
              </div>
              <v-layout justify-center align-center fill-height>
                <template>
                  <qrcode-vue ref="qrcode" renderAs="svg" :value="link" size="300" level="H"></qrcode-vue>
                </template>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn flat block color="primary" @click="exportSVG()">
            Baixar
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
      </template>

      <v-layout pt-4 row wrap justify-space-around fill-height>
        <v-flex xs12 sm11>
          <v-text-field
            readonly
            label="Nome da Rede"
            v-model="rede.nome"
          ></v-text-field>
        </v-flex>

        <template v-if="rede.representante">
          <v-flex xs12 sm5>
            <v-text-field
              readonly
              label="CPF do representante"
              v-model="rede.representante.cpf"
              mask="###.###.###-##"
              class="text-xs-center"
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              readonly
              label="Nome do Representante"
              v-model="rede.representante.nome"
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              readonly
              label="Sobrenome do Representante"
              v-model="rede.representante.sobrenome"
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              readonly
              label="Telefone do Representante"
              v-model="rede.representante.telefone"
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
              readonly
              label="Email do Representante"
              v-model="rede.representante.email"
            ></v-text-field>
          </v-flex>
        </template>

        <template v-if="empresas.length > 0">
          <v-flex xs12 class="text-xs-center pt-2 pb-2">
            <h2 class="gray--text">Empresas da Rede</h2>
          </v-flex>
          <v-flex xs12>
            <v-list>
              <v-list-tile v-for="(item, index) in empresas" :key="index" @click="empresaSelecionada = item, dialogDetalhes = true">
                <v-list-tile-avatar>
                  <v-icon>business</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.nome_fantasia || item.nome || item.razao_social }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ item.cnpj }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </template>

      </v-layout>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="$emit('fechar')">Voltar</v-btn>
    </v-card-actions>

    <v-dialog lazy width="600" v-model="dialogDetalhes" :fullscreen="$vuetify.breakpoint.xs">
      <v-card>
        <v-card-title class="headline">Detalhes da Empresa</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field readonly label="Nome Fantasia" :value="empresaSelecionada && (empresaSelecionada.nome_fantasia || empresaSelecionada.nome || '-')" />
            </v-flex>
            <v-flex xs6>
              <v-text-field readonly label="Razão Social" :value="empresaSelecionada && (empresaSelecionada.razao_social || '-')" />
            </v-flex>
            <v-flex xs6>
              <v-text-field readonly label="CNPJ" :value="empresaSelecionada && (empresaSelecionada.cnpj || '-')" />
            </v-flex>
            <template v-if="empresaSelecionada && empresaSelecionada.endereco">
              <v-flex xs8>
                <v-text-field readonly label="Logradouro" :value="empresaSelecionada.endereco.logradouro" />
              </v-flex>
              <v-flex xs4>
                <v-text-field readonly label="Número" :value="empresaSelecionada.endereco.numero" />
              </v-flex>
              <v-flex xs6>
                <v-text-field readonly label="Cidade" :value="empresaSelecionada.endereco.cidade" />
              </v-flex>
              <v-flex xs6>
                <v-text-field readonly label="Bairro" :value="empresaSelecionada.endereco.bairro" />
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="primary" @click="dialogDetalhes = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import settings from '@/settings'
import QrcodeVue from 'qrcode.vue'
import { saveAs } from 'file-saver'

export default {
  components: { QrcodeVue },
  props: ['rede'],
  data () {
    return {
      qrcode: false,
      empresas: [],
      dialogDetalhes: false,
      empresaSelecionada: undefined
    }
  },
  computed: {
    link () {
      if (this.rede && this.rede.matriz) return `${settings.apetrusGo}/${this.rede.matriz.cnpj}/`
      return undefined
    }
  },
  mounted () {
    if (this.rede) this.carregarEmpresas()
  },
  watch: {
    rede (val) {
      if (val) this.carregarEmpresas()
    }
  },
  methods: {
    exportSVG () {
      var svg = this.$refs.qrcode.$el
      var clone = svg.cloneNode(true)
      this.parseStyles(clone)
      var svgDocType = document.implementation.createDocumentType('svg', '-//W3C//DTD SVG 1.1//EN', 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd')
      var svgDoc = document.implementation.createDocument('http://www.w3.org/2000/svg', 'svg', svgDocType)
      svgDoc.replaceChild(clone, svgDoc.documentElement)
      var svgData = (new XMLSerializer()).serializeToString(svgDoc)
      var blob = new Blob([svgData.replace(/></g, '>' + '\n' + '<')])
      saveAs(blob, `qrcode-${this.rede.matriz.nome_fantasia || 'rede'}.svg`)
    },
    parseStyles (svg) {
      var styleSheets = []
      var i
      var docStyles = svg.ownerDocument.styleSheets
      for (i = 0; i < docStyles.length; i++) styleSheets.push(docStyles[i])
      if (!styleSheets.length) return
      var defs = svg.querySelector('defs') || document.createElementNS('http://www.w3.org/2000/svg', 'defs')
      if (!defs.parentNode) svg.insertBefore(defs, svg.firstElementChild)
      svg.matches = svg.matches || svg.webkitMatchesSelector || svg.mozMatchesSelector || svg.msMatchesSelector || svg.oMatchesSelector
      for (i = 0; i < styleSheets.length; i++) {
        var currentStyle = styleSheets[i]
        var rules
        try { rules = currentStyle.cssRules } catch (e) { continue }
        var style = document.createElement('style')
        var l = rules && rules.length
        for (var j = 0; j < l; j++) {
          var selector = rules[j].selectorText
          if (!selector) continue
          if ((svg.matches && svg.matches(selector)) || svg.querySelector(selector)) {
            var cssText = rules[j].cssText
            style.innerHTML += cssText + '\n'
          }
        }
        if (style.innerHTML) defs.appendChild(style)
      }
    },
    carregarEmpresas () {
      if (!this.rede) return
      this.$store.dispatch('pegarEmpresasPorRede', { id_rede_empresa: this.rede.id_rede_empresa || this.rede.id_rede || this.rede.id })
        .then(json => { this.empresas = json || [] })
        .catch(() => { this.empresas = [] })
    }
  }
}
</script>

<style>
.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, transparent 72px);
}
</style>
